var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticClass: "pageSize",
      staticStyle: { margin: "0 auto", "padding-top": "15px" },
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-row",
            [
              _c("el-col", {
                staticClass: "el-tabs__item",
                staticStyle: { height: "35px" },
                attrs: { span: 1 },
              }),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticClass: "suitability_home left_text_align",
                  staticStyle: { cursor: "pointer" },
                  attrs: { span: 14 },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.backHome.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-s-home" }),
                  _vm._v("返回主页菜单"),
                  _c("div", { staticClass: "imgs_logo" }),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticClass: "suitability_home right_text_align",
                  staticStyle: { cursor: "pointer" },
                  attrs: { span: 9 },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.logoutAccount.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "font_title_email" }, [
                    _vm._v(_vm._s(_vm.account)),
                  ]),
                  _c("span", [_vm._v("[退出]")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { width: "100%", height: "197px" } },
        [
          _c(
            "el-row",
            {
              staticStyle: {
                display: "flex",
                width: "100%",
                height: "200px",
                "align-items": "flex-end",
              },
            },
            [
              _c("el-row", {
                staticClass: "main_bg_img",
                staticStyle: {
                  display: "flex",
                  width: "100%",
                  height: "200px",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            "align-items": "center",
            width: "100%",
            height: "auto",
            "background-color": "#FBFBFB",
          },
        },
        [
          _c(
            "el-row",
            {
              staticStyle: {
                display: "flex",
                width: "90%",
                height: "100%",
                border: "1px solid #cccccc",
                "box-shadow": "0px 16px 21px 0px rgb(208 208 208)",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "align-items": "center",
                    width: "100%",
                    height: "100%",
                    "background-color": "#ffffff",
                  },
                },
                [
                  _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticStyle: {
                        display: "flex",
                        "align-items": "flex-start",
                        width: "92%",
                        height: "100%",
                      },
                    },
                    [
                      _c(
                        "el-tabs",
                        {
                          staticClass: "tabs_show_class",
                          staticStyle: { width: "100%", "margin-top": "36px" },
                          on: { "tab-click": _vm.handleClick },
                          model: {
                            value: _vm.activeName,
                            callback: function ($$v) {
                              _vm.activeName = $$v
                            },
                            expression: "activeName",
                          },
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "基金奖词云图", name: "chart" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    width: "100%",
                                    height: "815px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "100%",
                                        height: "44px",
                                        "justify-content": "flex-end",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            width: "184px",
                                            height: "80%",
                                            "border-radius": "10px",
                                            "align-items": "center",
                                            "justify-content": "space-around",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button-group",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: _vm.cssGoon1,
                                                    size: "medium",
                                                    round: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.tagClick(1)
                                                    },
                                                  },
                                                },
                                                [_vm._v("获奖")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: _vm.cssGoon2,
                                                    size: "medium",
                                                    round: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.tagClick(2)
                                                    },
                                                  },
                                                },
                                                [_vm._v("提名")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "600px",
                                    },
                                    attrs: { id: "echartsWordcloud" },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "100%",
                                        height: "40px",
                                        "align-items": "center",
                                        "font-size": "14px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "1",
                                            "justify-content": "flex-start",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "*截止日期: " + _vm._s(_vm.date)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "历年基金奖", name: "award" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    width: "100%",
                                    height: "100%",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "column",
                                        width: "100%",
                                        height: "140px",
                                        "border-bottom": "2px solid #cccccc",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            width: "100%",
                                            height: "60px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "align-items": "center",
                                                width: "250px",
                                                height: "60px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    width: "200px",
                                                    height: "32px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "flex-start",
                                                        "align-items": "center",
                                                        width: "100px",
                                                        height: "100%",
                                                        color: "#000000",
                                                        "font-weight": "550",
                                                      },
                                                    },
                                                    [_vm._v("获奖年度")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        placeholder: "",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        change: _vm.yearChange,
                                                      },
                                                      model: {
                                                        value: _vm.hj_value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.hj_value = $$v
                                                        },
                                                        expression: "hj_value",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.yearList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item,
                                                          attrs: {
                                                            label: item,
                                                            value: item,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "align-items": "center",
                                                width: "250px",
                                                height: "60px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    width: "200px",
                                                    height: "32px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "flex-start",
                                                        "align-items": "center",
                                                        width: "140px",
                                                        height: "100%",
                                                        color: "#000000",
                                                        "font-weight": "550",
                                                      },
                                                    },
                                                    [_vm._v("基金奖项")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        placeholder: "",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.fundAwardChange,
                                                      },
                                                      model: {
                                                        value: _vm.jj_value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.jj_value = $$v
                                                        },
                                                        expression: "jj_value",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.fundAwardList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item,
                                                          attrs: {
                                                            label: item,
                                                            value: item,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "align-items": "center",
                                                width: "250px",
                                                height: "60px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    width: "200px",
                                                    height: "32px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "flex-start",
                                                        "align-items": "center",
                                                        width: "100px",
                                                        height: "100%",
                                                        color: "#000000",
                                                        "font-weight": "550",
                                                      },
                                                    },
                                                    [_vm._v("资产类型")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        placeholder: "",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.broadCategoryChange,
                                                      },
                                                      model: {
                                                        value: _vm.zc_value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.zc_value = $$v
                                                        },
                                                        expression: "zc_value",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.broadCategoryList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item,
                                                          attrs: {
                                                            label: item,
                                                            value: item,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "align-items": "center",
                                                width: "250px",
                                                height: "60px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    width: "200px",
                                                    height: "32px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "flex-start",
                                                        "align-items": "center",
                                                        width: "100px",
                                                        height: "100%",
                                                        color: "#000000",
                                                        "font-weight": "550",
                                                      },
                                                    },
                                                    [_vm._v("基金类型")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        placeholder: "",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.fundCategoryChange,
                                                      },
                                                      model: {
                                                        value: _vm.fl_value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.fl_value = $$v
                                                        },
                                                        expression: "fl_value",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.fundCategoryList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item,
                                                          attrs: {
                                                            label: item,
                                                            value: item,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            width: "100%",
                                            height: "60px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "align-items": "center",
                                                width: "250px",
                                                height: "60px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    width: "200px",
                                                    height: "32px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "flex-start",
                                                        "align-items": "center",
                                                        width: "100px",
                                                        height: "100%",
                                                        color: "#000000",
                                                        "font-weight": "550",
                                                      },
                                                    },
                                                    [_vm._v("基金公司")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        clearable: "",
                                                        filterable: "",
                                                        placeholder: "",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        clear: function (
                                                          $event
                                                        ) {
                                                          return _vm.clearTemp(
                                                            2
                                                          )
                                                        },
                                                        change:
                                                          _vm.fundCompanyChange,
                                                      },
                                                      model: {
                                                        value: _vm.gs_value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.gs_value = $$v
                                                        },
                                                        expression: "gs_value",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.fundCompanyList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item,
                                                          attrs: {
                                                            label: item,
                                                            value: item,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "align-items": "center",
                                                width: "250px",
                                                height: "60px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    width: "200px",
                                                    height: "32px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "flex-start",
                                                        "align-items": "center",
                                                        width: "140px",
                                                        height: "100%",
                                                        color: "#000000",
                                                        "font-weight": "550",
                                                      },
                                                    },
                                                    [_vm._v("时任基金经理")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        clearable: "",
                                                        filterable: "",
                                                        placeholder: "",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        clear: function (
                                                          $event
                                                        ) {
                                                          return _vm.clearTemp(
                                                            1
                                                          )
                                                        },
                                                        change:
                                                          _vm.fundManagerChange,
                                                      },
                                                      model: {
                                                        value: _vm.jl_value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.jl_value = $$v
                                                        },
                                                        expression: "jl_value",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.managerTempList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item,
                                                          attrs: {
                                                            label: item,
                                                            value: item,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                width: "250px",
                                                height: "60px",
                                                "align-items": "center",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    width: "90px",
                                                    height: "34px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.searchClick()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("查找")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "100%",
                                        height: "100%",
                                        "margin-top": "16px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-table",
                                        {
                                          key: Math.random(),
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            data: _vm.tableData,
                                            "default-sort":
                                              _vm.sortTitle != "awardYear"
                                                ? {
                                                    prop: _vm.sortTitle,
                                                    order: "descending",
                                                  }
                                                : {
                                                    prop: "awardYear",
                                                    order: "descending",
                                                  },
                                          },
                                          on: { "sort-change": _vm.sortChange },
                                        },
                                        [
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              type: "index",
                                              label: "序号",
                                              width: "60",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              sortable: "custom",
                                              prop: "awardYear",
                                              label: "获奖年度",
                                              width: "100",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "awardType",
                                              label: "基金奖项",
                                              width: "80",
                                              "show-overflow-tooltip": "",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "csdcc",
                                              label: "基金代码",
                                              width: "100",
                                              align: "center",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "fundName",
                                              label: "基金名称",
                                              width: "200",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "fundCompanyShort",
                                              label: "基金公司",
                                              width: "120",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "managerName1",
                                              label: "时任基金经理",
                                              align: "center",
                                              width: "140",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.mergeNameFilter(
                                                            scope.row
                                                              .managerName1,
                                                            scope.row
                                                              .managerName2,
                                                            scope.row
                                                              .managerName3,
                                                            scope.row
                                                              .managerName4
                                                          )
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ]),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "startDate1",
                                              label: "任职日期",
                                              width: "100",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "publishDate",
                                              sortable: "custom",
                                              label: "获奖日期",
                                              width: "100",
                                              align: "left",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "fundNameCurrent",
                                              label: "基金名称(新)",
                                              width: "220",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "awardsCategory",
                                              label: "获奖类别",
                                              width: "140",
                                              "show-overflow-tooltip": "",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "categoryName",
                                              label: "基金类型",
                                              width: "200",
                                              "show-overflow-tooltip": "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "100%",
                                        height: "50px",
                                        "margin-top": "20px",
                                      },
                                    },
                                    [
                                      (_vm.pagination.count > 10 ? true : false)
                                        ? _c("el-pagination", {
                                            attrs: {
                                              "current-page": _vm.params.page,
                                              "page-sizes": [
                                                10, 20, 50, 100, 200,
                                              ],
                                              "page-size": _vm.pagination.limit,
                                              layout:
                                                "total, sizes, prev, pager, next, jumper",
                                              total:
                                                (_vm.pagination &&
                                                  _vm.pagination.count) ||
                                                0,
                                            },
                                            on: {
                                              "size-change":
                                                _vm.handleSizeChange,
                                              "current-change":
                                                _vm.handleCurrentChange,
                                              "update:currentPage": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.params,
                                                  "page",
                                                  $event
                                                )
                                              },
                                              "update:current-page": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.params,
                                                  "page",
                                                  $event
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            {
                              attrs: { label: "获奖公司列表", name: "company" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    width: "100%",
                                    height: "100%",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "column",
                                        width: "100%",
                                        height: "110px",
                                        "border-bottom": "2px solid #cccccc",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            width: "100%",
                                            height: "60px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "align-items": "center",
                                                width: "250px",
                                                height: "60px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    width: "200px",
                                                    height: "32px",
                                                  },
                                                },
                                                [
                                                  _c("el-autocomplete", {
                                                    staticClass: "inline-input",
                                                    attrs: {
                                                      clearable: "",
                                                      "fetch-suggestions":
                                                        _vm.querySearch,
                                                      placeholder:
                                                        "输入公司名称或首拼查找",
                                                    },
                                                    on: {
                                                      select: _vm.handleSelect,
                                                      clear: function ($event) {
                                                        return _vm.clearCompanySearch()
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.companyKeyword,
                                                      callback: function ($$v) {
                                                        _vm.companyKeyword = $$v
                                                      },
                                                      expression:
                                                        "companyKeyword",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "100%",
                                        height: "100%",
                                        "margin-top": "16px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-table",
                                        {
                                          key: Math.random(),
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            data: _vm.awardCompanyData,
                                            "default-sort":
                                              _vm.companySortTitle !=
                                              "awardAllocCount"
                                                ? {
                                                    prop: _vm.companySortTitle,
                                                    order: "descending",
                                                  }
                                                : {
                                                    prop: "awardAllocCount",
                                                    order: "descending",
                                                  },
                                            "sort-orders":
                                              "['descending', null]",
                                          },
                                          on: {
                                            "sort-change":
                                              _vm.sortCompanyChange,
                                          },
                                        },
                                        [
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              type: "index",
                                              label: "序号",
                                              width: "60",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "fundCompany",
                                              label: "基金公司名称",
                                              width: "220",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.goCompanyModule(
                                                  _vm.scope.row.fundCompany
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "inceptionDate",
                                              label: "成立日期",
                                              width: "120",
                                              "show-overflow-tooltip": "",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: "",
                                                align: "center",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c("span", [
                                                    _vm._v("获奖次数"),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                staticStyle: {
                                                  "background-color":
                                                    "red !important",
                                                },
                                                attrs: {
                                                  prop: "awardAllocCount",
                                                  sortable: "custom",
                                                  label: "权益",
                                                  "min-width": "120",
                                                  align: "center",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("div", [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "text-decoration":
                                                                  "none",
                                                              },
                                                              attrs: {
                                                                href: "javascript:;",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.goFundAwardPanel(
                                                                      1,
                                                                      scope.row
                                                                        .fundCompany
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .awardAllocCount
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "awardFxincCount",
                                                  sortable: "custom",
                                                  label: "固收",
                                                  "min-width": "120",
                                                  align: "center",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("div", [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "text-decoration":
                                                                  "none",
                                                              },
                                                              attrs: {
                                                                href: "javascript:;",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.goFundAwardPanel(
                                                                      2,
                                                                      scope.row
                                                                        .fundCompany
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .awardFxincCount
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "awardCount",
                                                  sortable: "custom",
                                                  label: "合计",
                                                  "min-width": "120",
                                                  align: "center",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("div", [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "text-decoration":
                                                                  "none",
                                                              },
                                                              attrs: {
                                                                href: "javascript:;",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.goFundAwardPanel(
                                                                      3,
                                                                      scope.row
                                                                        .fundCompany
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .awardCount
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              }),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: "",
                                                align: "center",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c("span", [
                                                    _vm._v("提名次数"),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                staticStyle: {
                                                  "background-color":
                                                    "red !important",
                                                },
                                                attrs: {
                                                  prop: "nominateAllocCount",
                                                  sortable: "custom",
                                                  label: "权益",
                                                  "min-width": "120",
                                                  align: "center",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("div", [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "text-decoration":
                                                                  "none",
                                                              },
                                                              attrs: {
                                                                href: "javascript:;",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.goFundAwardPanel(
                                                                      4,
                                                                      scope.row
                                                                        .fundCompany
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .nominateAllocCount
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "nominateFxincCount",
                                                  sortable: "custom",
                                                  label: "固收",
                                                  "min-width": "120",
                                                  align: "center",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("div", [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "text-decoration":
                                                                  "none",
                                                              },
                                                              attrs: {
                                                                href: "javascript:;",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.goFundAwardPanel(
                                                                      5,
                                                                      scope.row
                                                                        .fundCompany
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .nominateFxincCount
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              }),
                                              _vm._v(" "),
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "nominateCount",
                                                  sortable: "custom",
                                                  label: "合计",
                                                  "min-width": "120",
                                                  align: "center",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("div", [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticStyle: {
                                                                "text-decoration":
                                                                  "none",
                                                              },
                                                              attrs: {
                                                                href: "javascript:;",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.goFundAwardPanel(
                                                                      6,
                                                                      scope.row
                                                                        .fundCompany
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .nominateCount
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              }),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "100%",
                                        height: "50px",
                                        "margin-top": "20px",
                                      },
                                    },
                                    [
                                      (
                                        _vm.awardCompanyPagination.count > 10
                                          ? true
                                          : false
                                      )
                                        ? _c("el-pagination", {
                                            attrs: {
                                              "current-page":
                                                _vm.awardCompanyParams.page,
                                              "page-sizes": [
                                                10, 20, 50, 100, 200,
                                              ],
                                              "page-size":
                                                _vm.awardCompanyPagination
                                                  .limit,
                                              layout:
                                                "total, sizes, prev, pager, next, jumper",
                                              total:
                                                (_vm.awardCompanyPagination &&
                                                  _vm.awardCompanyPagination
                                                    .count) ||
                                                0,
                                            },
                                            on: {
                                              "size-change":
                                                _vm.handleSizeChange2,
                                              "current-change":
                                                _vm.handleCurrentChange2,
                                              "update:currentPage": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.awardCompanyParams,
                                                  "page",
                                                  $event
                                                )
                                              },
                                              "update:current-page": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.awardCompanyParams,
                                                  "page",
                                                  $event
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: "获奖基金经理列表",
                                name: "manager",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    width: "100%",
                                    height: "100%",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "column",
                                        width: "100%",
                                        height: "110px",
                                        "border-bottom": "2px solid #cccccc",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            width: "100%",
                                            height: "60px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "align-items": "center",
                                                width: "250px",
                                                height: "60px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    width: "200px",
                                                    height: "32px",
                                                  },
                                                },
                                                [
                                                  _c("el-autocomplete", {
                                                    staticClass: "inline-input",
                                                    attrs: {
                                                      clearable: "",
                                                      "fetch-suggestions":
                                                        _vm.queryManagerSearch,
                                                      placeholder:
                                                        "输入基金经理名称或首拼查找",
                                                    },
                                                    on: {
                                                      select:
                                                        _vm.handleManagerSelect,
                                                      clear: function ($event) {
                                                        return _vm.clearManagerSearch()
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.managerKeyword,
                                                      callback: function ($$v) {
                                                        _vm.managerKeyword = $$v
                                                      },
                                                      expression:
                                                        "managerKeyword",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "100%",
                                        height: "100%",
                                        "margin-top": "16px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-table",
                                        {
                                          key: Math.random(),
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            data: _vm.awardManagerData,
                                            "default-sort":
                                              _vm.managerSortTitle !=
                                              "awardCount"
                                                ? {
                                                    prop: _vm.managerSortTitle,
                                                    order: "descending",
                                                  }
                                                : {
                                                    prop: "awardCount",
                                                    order: "descending",
                                                  },
                                            "sort-orders":
                                              "['descending', null]",
                                          },
                                          on: {
                                            "sort-change":
                                              _vm.sortManagerChange,
                                          },
                                        },
                                        [
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              type: "index",
                                              label: "序号",
                                              width: "60",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "managerName",
                                              label: "基金经理名称",
                                              width: "120",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "awardCount",
                                              sortable: "custom",
                                              label: "获奖次数",
                                              width: "100",
                                              "show-overflow-tooltip": "",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("div", [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticStyle: {
                                                            "text-decoration":
                                                              "none",
                                                          },
                                                          attrs: {
                                                            href: "javascript:;",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.goFundAwardPanel2(
                                                                1,
                                                                scope.row
                                                                  .managerName,
                                                                scope.row
                                                                  .broadCategoryId
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .awardCount
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                            ]),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "nominateCount",
                                              sortable: "custom",
                                              label: "提名次数",
                                              width: "100",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("div", [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticStyle: {
                                                            "text-decoration":
                                                              "none",
                                                          },
                                                          attrs: {
                                                            href: "javascript:;",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.goFundAwardPanel2(
                                                                2,
                                                                scope.row
                                                                  .managerName,
                                                                scope.row
                                                                  .broadCategoryId
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .nominateCount
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                            ]),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "awardInfoList",
                                              label: "获奖明细",
                                              width: "240",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.nullFilter(
                                                            scope.row
                                                              .awardInfoList
                                                          )
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ]),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "nominateInfoList",
                                              label: "提名明细",
                                              width: "240",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.nullFilter(
                                                            scope.row
                                                              .nominateInfoList
                                                          )
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ]),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "broadCategoryId",
                                              sortable: "custom",
                                              label: "资产类型",
                                              width: "100",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            key: Math.random(),
                                            attrs: {
                                              prop: "fundCompanyShort",
                                              label: "曾任基金公司",
                                              width: "160",
                                              align: "left",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "100%",
                                        height: "50px",
                                        "margin-top": "20px",
                                      },
                                    },
                                    [
                                      (
                                        _vm.awardManagerPagination.count > 10
                                          ? true
                                          : false
                                      )
                                        ? _c("el-pagination", {
                                            attrs: {
                                              "current-page":
                                                _vm.awardManagerParams.page,
                                              "page-sizes": [
                                                10, 20, 50, 100, 200,
                                              ],
                                              "page-size":
                                                _vm.awardManagerPagination
                                                  .limit,
                                              layout:
                                                "total, sizes, prev, pager, next, jumper",
                                              total:
                                                (_vm.awardManagerPagination &&
                                                  _vm.awardManagerPagination
                                                    .count) ||
                                                0,
                                            },
                                            on: {
                                              "size-change":
                                                _vm.handleSizeChange3,
                                              "current-change":
                                                _vm.handleCurrentChange3,
                                              "update:currentPage": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.awardManagerParams,
                                                  "page",
                                                  $event
                                                )
                                              },
                                              "update:current-page": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.awardManagerParams,
                                                  "page",
                                                  $event
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }